/*
 * @Description:
 * @Author: lijinpeng
 * @Date: 2024-05-08 11:03:41
 * @LastEditTime: 2024-05-18 10:34:48
 * @LastEditors: lijinpeng
 */
import { get, post, prefix } from './base';

// 获取经办人信息
export function getAgent(params) {
  return get(`${prefix}esign/getAgent`, params);
}

// 获取业务经办人信息
export function getETCAgent(params) {
  return get(`${prefix}data-statistics/etc/agent/company/getAgent`, params);
}

// 经办人获取短信验证码
export function getAgentSMSCode(data) {
  return post(`${prefix}data-statistics/etc/agent/company/get-sms-code`, data);
}

// 经办人短信验证码回验
export function postAgentSMSCodeValidate(data) {
  return post(`${prefix}data-statistics/etc/agent/company/post-sms-code`, data);
}

// 获取企业认证信息补全和经办人短信验证码有效性
export function getAgentSMSValidate(data) {
  return post(`${prefix}data-statistics/etc/agent/company/sms-validate`, data);
}
